import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { ComponentTypesReducer } from "../reducers/ComponentTypeReducer";

const ComponentTypesContext = createContext({
	state: ComponentTypesReducer.getInitialState(),
	actions: ComponentTypesReducer.actions,
});
export const useComponentTypesContext = () => useContext(ComponentTypesContext);

export const ComponentTypeProvider = ({
	children,
}: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: ComponentTypesReducer.getInitialState(),
		reducers: ComponentTypesReducer.caseReducers,
	});
	return (
		<ComponentTypesContext.Provider value={{ state, actions }}>
			{children}
		</ComponentTypesContext.Provider>
	);
};
